import { useEffect, useState } from "react";
import type { AdminEmailDailyCountsResponse, AdminEmailDateRange } from "../models/admin-email.models";
import { getAdminEmailDailyCounts, getAdminEmailErrorMessage } from "../services/admin-email.service";

// Request full daily totals independently of the visible message page.
// The backend declares incomplete days explicitly when the mail provider cannot supply an exact count.
export const useAdminEmailDailyCounts = (mailboxId: string, range: AdminEmailDateRange) => {
  const [response, setResponse] = useState<AdminEmailDailyCountsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    setResponse(null);
    setLoading(true);
    setError(null);

    getAdminEmailDailyCounts(mailboxId, { from: range.from, to: range.to }, controller.signal)
      .then((result) => {
        if (!controller.signal.aborted) {
          setResponse(result);
        }
      })
      .catch((requestError) => {
        if (!controller.signal.aborted) {
          setError(getAdminEmailErrorMessage(requestError));
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      });

    return () => controller.abort();
  }, [mailboxId, range.from, range.to]);

  return { response, loading, error };
};
